import React, { Suspense, lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
// 懒加载组件
const Layout = lazy(() => import('@/layout'));
const Home = lazy(() => import('@/pages/home'));
const HomeMg = lazy(() => import('@/pages/home-mg'));
const Login = lazy(() => import('@/pages/login'));
const RobotMg = lazy(() => import('@/pages/robot-mg'));
const TaskMg = lazy(() => import('@/pages/task-mg'));
const MemoryMg = lazy(() => import('@/pages/memory-mg'));
const SystemMg = lazy(() => import('@/pages/system-mg'));
const SceneMg = lazy(() => import('@/pages/scene-mg'));
const AddEditRobot = lazy(() => import('@/pages/robot-mg/add-edit-robot'));
const ModelMg = lazy(() => import('@/pages/model-mg'));
const MemberMg = lazy(() => import('@/pages/member-mg'));
const SpaceSetting = lazy(() => import('@/pages/space-settings'));
const VoiceInteraction = lazy(() => import('@/pages/voice-interaction'));
const RoleDetail = lazy(() => import('@/pages/voice-interaction/role-detail'));
const VoiceConfig = lazy(() => import('@/pages/voice-config'));
const TimbreMg = lazy(() => import('@/pages/source-mg/timbre-mg'));
const SceneDetail = lazy(() => import('@/pages/scene-mg/scene-detail'));
const RobotConfig = lazy(() => import('@/pages/robot-mg/robot-config'));
const SourceMg = lazy(() => import('@/pages/source-mg'));
const KnowledgeMg = lazy(() => import('@/pages/source-mg/knowledge-mg'));
const VoicePrintMg = lazy(() => import('@/pages/source-mg/voice-print-mg'));
const ActionGen = lazy(() => import('@/pages/source-mg/action-mg/action-gen'));
const TestLogin = lazy(() => import('@/pages/test-login'));
const SkillStore = lazy(() => import('@/pages/skill-store'));
const DanceActions = lazy(() => import('@/pages/skill-store/dance-actions'));
const DanceActionDetail = lazy(() => import('@/pages/skill-store/dance-actions/detail'));
const Esports = lazy(() => import('@/pages/skill-store/esports'));
const EsportDetail = lazy(() => import('@/pages/skill-store/esports/detail'));
const CommercialServices = lazy(() => import('@/pages/skill-store/commercial-services'));
const CommercialServiceDetail = lazy(() => import('@/pages/skill-store/commercial-services/detail'));
const SceneCustomization = lazy(() => import('@/pages/skill-store/scene-customization'));
const PurchaseHistory = lazy(() => import('@/pages/skill-store/purchase-history'));
const Register = lazy(() => import('@/pages/register'));
const AddSkill = lazy(() => import('@/pages/robot-mg/add-skill'));

// 加载中组件
const PageLoading = () => (
  <Spin indicator={<LoadingOutlined spin />} size="large" fullscreen />
);

// Suspense 包裹组件的高阶函数
const lazyLoad = (Component: React.LazyExoticComponent<any>) => (
  <Suspense fallback={<PageLoading />}>
    <Component />
  </Suspense>
);

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/page/home-mg" replace={true} />,
  },
  {
    path: '/test-login',
    element: lazyLoad(TestLogin),
  },
  {
    path: '/login',
    element: lazyLoad(Login),
  },
  {
    path: '/register',
    element: lazyLoad(Register),
  },
  {
    path: '/page/scene-detail',
    element: lazyLoad(SceneDetail),
  },
  {
    path: '/page/robot-config',
    element: lazyLoad(RobotConfig),
  },
  {
    path: '/page/robot-mg/add-skill',
    element: lazyLoad(AddSkill),
  },
  {
    path: '/page/action-gen',
    element: lazyLoad(ActionGen),
  },
  {
    path: '/page',
    element: lazyLoad(Layout),
    children: [
      {
        path: 'home-mg',
        element: lazyLoad(HomeMg),
      },
      {
        path: 'home',
        element: lazyLoad(Home),
      },
      {
        path: 'robot-mg',
        element: lazyLoad(RobotMg),
      },
      {
        path: 'add-edit-robot',
        element: lazyLoad(AddEditRobot),
      },
      // {
      //   path: 'robot-mg/add-skill',
      //   element: lazyLoad(AddSkill),
      // },
      {
        path: 'scene-mg',
        element: lazyLoad(SceneMg),
      },
      {
        path: 'source-mg',
        element: lazyLoad(SourceMg),
      },
      {
        path: 'task-mg',
        element: lazyLoad(TaskMg),
      },
      {
        path: 'knowledge-mg',
        element: lazyLoad(KnowledgeMg),
      },
      {
        path: 'memory-mg',
        element: lazyLoad(MemoryMg),
      },
      {
        path: 'system-mg',
        element: lazyLoad(SystemMg),
      },
      {
        path: 'model-mg',
        element: lazyLoad(ModelMg),
      },
      {
        path: 'member-mg',
        element: lazyLoad(MemberMg),
      },
      {
        path: 'space-setting',
        element: lazyLoad(SpaceSetting),
      },
      {
        path: 'timbre-mg',
        element: lazyLoad(TimbreMg),
      },
      {
        path: 'voice-print-mg',
        element: lazyLoad(VoicePrintMg),
      },
      {
        path: 'voice-interaction',
        element: lazyLoad(VoiceInteraction),
      },
      {
        path: 'role-detail',
        element: lazyLoad(RoleDetail),
      },
      {
        path: 'voice-config',
        element: lazyLoad(VoiceConfig),
      },
      {
        path: 'skill-store',
        element: lazyLoad(SkillStore),
      },
      {
        path: 'skill-store/dance-actions',
        element: lazyLoad(DanceActions),
      },
      {
        path: 'skill-store/dance-actions/detail',
        element: lazyLoad(DanceActionDetail),
      },
      {
        path: 'skill-store/purchase-history',
        element: lazyLoad(PurchaseHistory),
      },
      {
        path: 'skill-store/esports',
        element: lazyLoad(Esports),
      },
      {
        path: 'skill-store/esports/detail',
        element: lazyLoad(EsportDetail),
      },
      {
        path: 'skill-store/commercial-services',
        element: lazyLoad(CommercialServices),
      },
      {
        path: 'skill-store/commercial-services/detail',
        element: lazyLoad(CommercialServiceDetail),
      },
      {
        path: 'skill-store/scene-customization',
        element: lazyLoad(SceneCustomization),
      }
    ],
  },
]);
